// extracted by mini-css-extract-plugin
module.exports = {"arrow":"lN","dropMenu":"lO","dropMenuInner":"lP","itemborder":"lQ","dropDownCurrent":"lR","menuItem":"lS","langContainer":"lT","current":"lU","outlink":"lV"};